import { findRemarketingAttribution } from '@api/reports';
import {
  RemarketingAttributionResponse,
  RemarketingAttributionRow,
  RemarketingOutcome,
  RemarketingSequenceRow,
} from '@interfaces/reports/remarketingAttribution';
import { PaymentConversionPeriod } from '@interfaces/reports/paymentConversion';
import { ReportFiltersInput, useReportRequest } from '../useReportRequest';

export const emptyOutcome: RemarketingOutcome = {
  sends: 0,
  returned: 0,
  purchased: 0,
  returnRate: 0,
  purchaseRate: 0,
  revenue: 0,
  revenuePerSend: 0,
};

export const emptyResponse: RemarketingAttributionResponse = {
  summary: emptyOutcome,
  rows: [],
  bySequence: [],
};

export function useRemarketingAttribution(
  filters: ReportFiltersInput,
  timeAggregationPeriod: PaymentConversionPeriod = 'MONTH',
  attributionWindowDays = 7,
) {
  const { data, isLoading, hasFailed } = useReportRequest<RemarketingAttributionResponse>(
    filters,
    timeAggregationPeriod,
    findRemarketingAttribution as any,
    emptyResponse,
    (payload) => ({
      summary: { ...emptyOutcome, ...(payload.summary ?? {}) },
      rows: (payload.rows ?? []).map(
        (row): RemarketingAttributionRow => ({
          ...emptyOutcome,
          ...row,
          period: row?.period ?? '',
        }),
      ),
      bySequence: (payload.bySequence ?? []).map(
        (row): RemarketingSequenceRow => ({
          ...emptyOutcome,
          ...row,
          orderNumber: row?.orderNumber ?? 0,
        }),
      ),
    }),
    { attributionWindowDays },
  );

  return {
    summary: data.summary,
    rows: data.rows,
    bySequence: data.bySequence,
    isLoading,
    hasFailed,
  };
}
